<template>
  <div class="container">
    <div class="row">
      <div id="column-left" class="col-sm-3 hidden-xs column-left">
        <div class="banner">
          <div class="item">
            <a href="#"
              ><img
                src="../assets/image/banners/LeftBanner.jpg"
                alt="Left Banner"
                class="img-responsive"
                style="width:100%"
            /></a>
          </div>
        </div>

        <div class="column-block">
          <div id="checkout-popular-products"></div>
        </div>
      </div>
      <div class="col-sm-9" id="content">
        <div class="panel-body">
          <div v-if="cartData.length > 0">
            <div class="table-responsive">
              <table class="table table-bordered table-hover">
                <thead>
                  <tr>
                    <td class="text-left">Product Name</td>
                    <td class="text-left">Brand</td>
                    <td class="text-right">Quantity</td>
                    <td class="text-right">Unit Price</td>
                    <td class="text-right">Total</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(product, index) in cartData" :key="index">
                    <td class="text-left">
                      <a :href="'#/product/' + product.id">{{ product.name }}</a>
                    </td>
                    <td class="text-left">{{ product.brand }}</td>
                    <td class="text-right">{{ product.quantity }}</td>
                    <td class="text-right">
                      ${{ product.price | numeral(0, 0) }}
                    </td>
                    <td class="text-right">
                      ${{ (product.price * product.quantity) | numeral(0, 0) }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td class="text-right" colspan="4">
                      <strong>Total:</strong>
                    </td>
                    <td class="text-right">${{ totalPrice | numeral(0, 0) }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div class="buttons">
              <div class="pull-right">
                <input
                  type="button"
                  data-loading-text="Loading..."
                  class="btn btn-primary"
                  id="button-confirm"
                  value="Confirm Order"
                  @click="confirmOrder()"
                />
              </div>
            </div>
          </div>
          <div v-if="cartData.length == 0 && !orderSuccess" style="text-align:center;">
            No product in cart.
          </div>
          <div v-if="orderSuccess" style="text-align:center;">
            <p style="font-size:15px;">Your order is complete.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BestSellers from "../components/product/BestSellers.vue";
import Latest from "../components/product/Latest.vue";
import Specials from "../components/product/Specials.vue";

import setCart from '../mixins/setCart';

export default {
  components: {
    BestSellers,
    Latest,
    Specials
  },
  mixins: [setCart],
  data() {
    return {
      cartData: JSON.parse(localStorage.getItem("basket")) || [],
      totalPrice: 0,
      orderSuccess: false,
      deviceId: ""
    };
  },
  methods: {
    calcTotalPrice() {
      var sum = 0;
      this.cartData.forEach(value => {
        value.price = value.price.replace(/[ ,.]/g, "");
        sum += parseInt(value.price) * value.quantity;
      });

      this.totalPrice = sum;
    },
    confirmOrder() {
      this.orderSuccess = true;

      const basketProducts = this.cartData.map(c => {
        return {
          productId: c.id,
          quantity: c.quantity,
          price: parseInt(c.price),
          currency: c.currency
        };
      });

      var sum = 0;
      basketProducts.forEach(value => {
        value.price = value.price;
        sum += parseInt(value.price) * value.quantity;
      });

      dengage("getContactKey", function(contact_key) {
        window.sgfLayer = {
          checkout: {
            step: "purchase",
            totalPrice: sum,
            currency: "USD",
            products: basketProducts
          }
        };
        if (contact_key) {
          window.sgfLayer.common = {
            userId: contact_key
          };
        } else {
          dengage("getDeviceId", function(device_id) {
            window.sgfLayer.common = {
              userId: device_id
            };
          });
        }
      });

      //dengage("sendDeviceEvent", "user_events", { event_type: "order" });
      /*dataLayer.push({
        event: 'dengage_event',
        dengage_table_name: 'user_events',
        dengage_event_data: {
          event_type: "order",
        }
      });*/
      dengage('ec:order', {
        order_id: Math.floor(Math.random() * 10000000)+1,
        item_count: this.cartData.length,
        total_amount: this.totalPrice,
        payment_method: 'card',
        shipping: this.cartData.length,
        discounted_price: this.totalPrice,
        coupon_code: '',
        // ... order_events tablosundaki ekstra kolonlar da olabilir
        cartItems: this.cartData.map(b => {
          return {
              product_id: b.id,
              product_variant_id: '1',
              quantity: b.quantity,
              unit_price: b.price,
              discounted_price: b.price,
              // ... shopping_cart_events_detail tablosundaki ekstra kolonlar da olabilir
          };
        }),
      });

      /*var basketItems = this.cartData.map(p => ({
        productId: p.id,
        variantId: 1,
        quantity: +p.quantity,
        price: +p.price,
        currency: p.currency,
      }));
      var totalPrice = this.cartData.reduce((acc, p) => {
        var price = +p.price;
        return acc + price;
      }, 0);*/
      //collector.orderSummary(basketItems, totalPrice, localStorage.getItem('basket_id'), localStorage.getItem('basket_id'), 'card', localStorage.getItem('contact_key'))

      this.cartData.length = 0;
      localStorage.setItem("basket", JSON.stringify(this.cartData));
      var basket_id = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
      localStorage.setItem('basket_id', basket_id);

      this.setCartForDengage();
    },
  },
  created() {
    this.calcTotalPrice();

    dengage("getContactKey", function(contact_key) {
      window.sgfLayer = {
        page: {
          pageUrl: "https://showcase.dengage.com/#/checkout/",
          category: "Checkout Page"
        }
      };
      if (contact_key) {
        window.sgfLayer.common = {
          userId: contact_key
        };
      } else {
        dengage("getDeviceId", function(device_id) {
          window.sgfLayer.common = {
            userId: device_id
          };
        });
      }
    });

    /*dengage("sendDeviceEvent", "user_events", {
      event_type: "page_view",
      page_url: window.location.href,
      page_type: "checkout",
      page_title: "Checkout Page"
    });*/
    /*dataLayer.push({
      event: 'dengage_event',
      dengage_table_name: 'user_events',
      dengage_event_data: {
        event_type: "page_view",
        page_url: window.location.href,
        page_type: "checkout",
        page_title: "Checkout Page"
      }
    });*/
    dengage('ec:beginCheckout', {
      // ... shopping_cart_events tablosundaki ekstra kolonlar da olabilir
      cartItems: this.cartData.map(b => {
        return {
          product_id: b.id,
          product_variant_id: '1',
          quantity: b.quantity,
          unit_price: b.price,
          discounted_price: b.price,
          // ... shopping_cart_events_detail tablosundaki ekstra kolonlar da olabilir
        };
      }),
    });
    dengage('setNavigation', {name: 'checkout'});
  }
};
</script>

<style scoped>
.panel-body {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Checkout.vue